module.exports = __webpack_public_path__ + "static/media/Mus-min.b993ff79.PNG";